import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

@Component({
  selector: 'lib-update-user-dialog',
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './update-user-dialog.component.html',
  styleUrl: './update-user-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DialogService],
})
export class UpdateUserDialogComponent {
  private ref = inject(DynamicDialogRef);
  private dialogConfig = inject(DynamicDialogConfig);

  email = new FormControl<string>(this.dialogConfig.data.email);
  user = new FormControl<string>(this.dialogConfig.data.user);

  cancel() {
    this.ref.close(false);
  }

  update() {
    this.ref.close({
      update: true,
      email: this.email.value,
      user: this.user.value,
    });
  }
}
